module.exports = ".textPageHeaderCon {\n  border-bottom: 1px solid lightgray;\n  background-color: rgb(219, 218, 221);\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/bookShared/bookeditoption/bookEditOptionPopups/pagenoposition/pagenoposition.component.css
// module id = ./src/app/bookShared/bookeditoption/bookEditOptionPopups/pagenoposition/pagenoposition.component.css
// module chunks = main